import { fetchRegInfo, sendRegClientInfo } from '../../api';

const state = {
  info: {},
  isFetching: false,
  form: {
    name: '',
  },
};

const getters = {
  form: ({ form }) => form,
  info: ({ info }) => info,
  isFetching: ({ isFetching }) => isFetching,
};

const actions = {
  loadDeviceInfo({ commit }, id) {
    commit('setFetching', true);
    fetchRegInfo(id)
      .then((res) => {
        commit('setInfo', res);
      })
      .finally(() => {
        commit('setFetching', false);
      });
  },
  createOrder({ commit }, { id, form }) {
    commit('setFetching', true);
    return sendRegClientInfo({
      id,
      payload: form,
    })
      .finally(() => {
        commit('setFetching', false);
      });
  },
};

const mutations = {
  // eslint-disable-next-line
  setFetching(state, payload) {
    // eslint-disable-next-line
    state.isFetching = !!payload;
  },
  // eslint-disable-next-line
  setInfo(state, payload) {
    // eslint-disable-next-line
    state.info = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
